module.exports = __webpack_public_path__ + "img/logo-paninti-partner.60dae7d.svg";